import React from "react";
import { motion } from "framer-motion";
import { resolveImg } from "@/lib/api";
import { Quote } from "lucide-react";

export default function Team({ team = {} }) {
  return (
    <section
      id="equipe"
      data-testid="team-section"
      className="relative bg-stone-900/40 py-14 md:py-20 border-y border-stone-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Portrait */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5"
          >
            <div className="relative">
              <div className="relative aspect-[4/5] overflow-hidden bg-stone-900">
                <img
                  src={resolveImg(team.photo)}
                  alt={team.name}
                  className="h-full w-full object-cover"
                />
                <div className="absolute top-5 left-5 bg-amber-700 text-stone-50 text-xs tracking-[0.2em] uppercase font-semibold px-4 py-2">
                  {team.title || "Destaque do Mês"}
                </div>
              </div>
              {team.photo2 && (
                <div className="mt-4 sm:mt-0 sm:absolute sm:-bottom-10 sm:-right-8 sm:w-[42%] aspect-square overflow-hidden sm:border-[10px] border-stone-950 shadow-xl">
                  <img
                    src={resolveImg(team.photo2)}
                    alt={`${team.name} — 2`}
                    className="h-full w-full object-cover"
                  />
                </div>
              )}
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="lg:col-span-7"
          >
            <span className="text-xs tracking-[0.3em] uppercase text-amber-500 font-semibold">
              {team.label || "Nossa Equipe"}
            </span>
            <Quote className="h-10 w-10 text-amber-600/40 mt-8" />
            <p className="font-serif text-2xl md:text-3xl lg:text-4xl leading-snug text-stone-100 mt-6 max-w-2xl">
              {team.tribute}
            </p>
            <div className="mt-10 flex items-center gap-4">
              <span className="h-px w-12 bg-amber-600" />
              <div>
                <p className="font-serif text-2xl text-stone-50">{team.name}</p>
                <p className="text-sm tracking-[0.15em] uppercase text-stone-400 mt-1">{team.role}</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
